import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import {PessoaFJ} from '../model/PessoaFJ';

@Injectable({
  providedIn: 'root'
})
export class SrfService {

  private BASE_URL = './rest/seguro/srf';

  constructor(private http: HttpClient) {
  }

  // Obtem o nome da Pessoa Física ou Razão Social da Pessoa Jurídica
  obterNomePessoaFJ(cpfCnpj: string): Observable<PessoaFJ> {
    return this.http.get<PessoaFJ>(`${this.BASE_URL}/nome/${cpfCnpj}`, blockUi());
//    .pipe(map(p => Object.assign(new DocumentoPac(), p)));
  }

}
